import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f6f579c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-wrap flex-grow-1" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-6"
}
const _hoisted_3 = {
  key: 1,
  class: "text-body-2 text-error"
}
const _hoisted_4 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis"
}
const _hoisted_5 = { class: "metricas mb-3" }
const _hoisted_6 = { class: "metrica" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Partidas", -1))
const _hoisted_8 = { class: "text-h6" }
const _hoisted_9 = { class: "text-caption text-medium-emphasis" }
const _hoisted_10 = { class: "metrica" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "% victorias", -1))
const _hoisted_12 = { class: "text-h6" }
const _hoisted_13 = { class: "text-caption text-medium-emphasis" }
const _hoisted_14 = { class: "metrica" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Rinde", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption text-medium-emphasis" }, " frente a su ELO ", -1))
const _hoisted_17 = {
  key: 0,
  class: "metrica"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption text-medium-emphasis" }, " Mata al general ", -1))
const _hoisted_19 = { class: "text-h6" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption text-medium-emphasis" }, " de sus partidas ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-subtitle-2 font-weight-bold mb-2" }, "En torneos", -1))
const _hoisted_22 = { class: "d-flex flex-wrap ga-1 mb-1" }
const _hoisted_23 = { class: "text-body-2 text-medium-emphasis mb-0" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-subtitle-2 font-weight-bold mb-2" }, " Según los puntos ", -1))
const _hoisted_25 = { class: "text-medium-emphasis" }
const _hoisted_26 = { class: "text-right" }
const _hoisted_27 = { class: "text-right text-caption text-medium-emphasis" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-subtitle-2 font-weight-bold mb-2" }, " Por temporada ", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fila-cuatro cabecera text-caption text-medium-emphasis" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Temporada"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-right" }, "Part."),
  /*#__PURE__*/_createElementVNode("span", { class: "text-right" }, "% vict."),
  /*#__PURE__*/_createElementVNode("span", { class: "text-right" }, "Rinde")
], -1))
const _hoisted_30 = { class: "text-medium-emphasis" }
const _hoisted_31 = { class: "text-right" }
const _hoisted_32 = { class: "text-right" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-subtitle-2 font-weight-bold mb-2" }, " Contra quién ", -1))
const _hoisted_34 = {
  key: 0,
  class: "text-caption text-medium-emphasis mb-0"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fila-cuatro cabecera text-caption text-medium-emphasis" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Rival"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-right" }, "Part."),
  /*#__PURE__*/_createElementVNode("span", { class: "text-right" }, "% vict."),
  /*#__PURE__*/_createElementVNode("span", { class: "text-right" }, "Rinde")
], -1))
const _hoisted_36 = ["onClick", "onKeydown"]
const _hoisted_37 = { class: "nombre" }
const _hoisted_38 = { class: "text-right" }
const _hoisted_39 = { class: "text-right" }
const _hoisted_40 = {
  key: 0,
  class: "text-center"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-caption text-medium-emphasis mb-0" }, " Del que mejor se le da al que peor, con 5 partidas o más. Pulsa uno para ver el cruce entero. ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-subtitle-2 font-weight-bold mb-2" }, " Quién lo lleva mejor ", -1))
const _hoisted_43 = {
  key: 0,
  class: "text-caption text-medium-emphasis mb-0"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fila-cuatro cabecera text-caption text-medium-emphasis" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Jugador"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-right" }, "Part."),
  /*#__PURE__*/_createElementVNode("span", { class: "text-right" }, "% vict."),
  /*#__PURE__*/_createElementVNode("span", { class: "text-right" }, "Rinde")
], -1))
const _hoisted_45 = { class: "text-right" }
const _hoisted_46 = { class: "text-right" }
const _hoisted_47 = {
  key: 0,
  class: "text-center"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-caption text-medium-emphasis mb-0" }, " Ordenados por «Rinde», con 5 partidas o más: lo bien que les va con él frente a lo que espera su ELO. ", -1))

import { computed, ref, watch } from "vue";
import type {
  FichaEjercitoDTO,
  FiltroEstadisticas,
} from "@/interfaces/Estadisticas";
import { getFichaEjercito } from "@/services/EstadisticasService";
import { mensajeDelBack } from "@/utils/mensajeDelBack";
import {
  colorBando,
  colorRinde,
  textoBando,
  textoDecimal,
  textoPorcentaje,
  textoRinde,
  textoTramo,
} from "@/utils/estadisticasEjercitos";

const JUGADORES_DE_ENTRADA = 5;


export default /*#__PURE__*/_defineComponent({
  __name: 'FichaEjercito',
  props: {
    modelValue: { type: Boolean },
    ejercito: {},
    filtro: {}
  },
  emits: ["update:modelValue", "cruce"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const ficha = ref<FichaEjercitoDTO | null>(null);
const cargando = ref(false);
const error = ref<string | null>(null);
const todosRivales = ref(false);
const todosJugadores = ref(false);

const cerrar = () => emit("update:modelValue", false);
const verCruce = (rival: string) => {
  if (ficha.value)
    emit("cruce", { ejercito: ficha.value.resumen.ejercito, rival });
};

// Se carga cada vez que se abre, con los filtros que haya en ese momento
watch(
  () => props.modelValue,
  async abierta => {
    if (!abierta || !props.ejercito) return;
    ficha.value = null;
    error.value = null;
    todosRivales.value = false;
    todosJugadores.value = false;
    cargando.value = true;
    try {
      ficha.value = await getFichaEjercito(props.ejercito, props.filtro);
    } catch (e) {
      error.value = mensajeDelBack(
        e,
        "No se ha podido cargar el ejército. Inténtalo de nuevo."
      );
    } finally {
      cargando.value = false;
    }
  }
);

// «2025 y 2026», «hasta 550, 600-650 y 700-750»
const enLista = (textos: string[]) =>
  textos.length <= 1
    ? textos.join("")
    : `${textos.slice(0, -1).join(", ")} y ${textos[textos.length - 1]}`;

const descripcionFiltro = computed(() => {
  const temporadas = [...(props.filtro.temporadas ?? [])].sort();
  const tramos = props.filtro.tramos ?? [];
  const partes = [
    temporadas.length === 0
      ? "Todas las temporadas"
      : `${temporadas.length === 1 ? "Temporada" : "Temporadas"} ${enLista(
          temporadas.map(String)
        )}`,
    tramos.length === 0
      ? "todos los puntos"
      : `${enLista(tramos.map(t => textoTramo(t).toLowerCase()))} puntos`,
    props.filtro.amistosas ? "con amistosas" : "sin amistosas",
  ];
  return partes.join(" · ");
});

// Lo que gana en partidas frente a lo que gana en torneos, dicho en una frase
const fraseTorneos = computed(() => {
  const resumen = ficha.value?.resumen;
  if (!resumen || resumen.torneos === 0) return "";
  const partidas = `Gana el ${textoPorcentaje(resumen.porcentaje)} de sus partidas`;
  const deSus =
    resumen.torneos === 1
      ? "su único torneo"
      : `sus ${resumen.torneos} torneos`;
  if (resumen.torneosGanados === 0)
    return `${partidas}, pero ${resumen.torneos === 1 ? "no ha ganado" : "ninguno de"} ${deSus}.`;
  return `${partidas} y ${resumen.torneosGanados} de ${deSus}.`;
});

// Los tres mejores y los tres peores; o todos, si se piden
const rivalesVisibles = computed(() => {
  const rivales = ficha.value?.rivales ?? [];
  if (todosRivales.value || rivales.length <= 6) return rivales;
  return [...rivales.slice(0, 3), ...rivales.slice(-3)];
});

const jugadoresVisibles = computed(() => {
  const jugadores = ficha.value?.jugadores ?? [];
  return todosJugadores.value
    ? jugadores
    : jugadores.slice(0, JUGADORES_DE_ENTRADA);
});

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "max-width": "560",
    scrollable: "",
    "onUpdate:modelValue": cerrar
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex align-start ga-2 pb-0 pr-2" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.ejercito), 1),
              (ficha.value?.resumen.bando)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 0,
                    size: "x-small",
                    color: _unref(colorBando)(ficha.value.resumen.bando),
                    class: "mt-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(textoBando)(ficha.value.resumen.bando)), 1)
                    ]),
                    _: 1
                  }, 8, ["color"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                variant: "text",
                size: "small",
                density: "comfortable",
                class: "mt-n1",
                "aria-label": "Cerrar",
                onClick: cerrar
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_subtitle, { class: "pb-2 text-wrap" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(descripcionFiltro.value), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "pt-0 px-3 px-sm-6" }, {
            default: _withCtx(() => [
              (cargando.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      color: "primary"
                    })
                  ]))
                : (error.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(error.value), 1))
                  : (ficha.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        (ficha.value.resumen.partidas === 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_4, " No hay partidas de este ejército con estos filtros. "))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                  _hoisted_7,
                                  _createElementVNode("div", _hoisted_8, _toDisplayString(ficha.value.resumen.partidas), 1),
                                  _createElementVNode("div", _hoisted_9, _toDisplayString(ficha.value.resumen.victorias) + "-" + _toDisplayString(ficha.value.resumen.empates) + "-" + _toDisplayString(ficha.value.resumen.derrotas), 1)
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                  _hoisted_11,
                                  _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(textoPorcentaje)(ficha.value.resumen.porcentaje)), 1),
                                  _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(textoDecimal)(ficha.value.resumen.puntosFavor)) + " a " + _toDisplayString(_unref(textoDecimal)(ficha.value.resumen.puntosContra)) + " de media ", 1)
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                  _hoisted_15,
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["text-h6", _unref(colorRinde)(ficha.value.resumen.rinde)])
                                  }, _toDisplayString(_unref(textoRinde)(ficha.value.resumen.rinde)), 3),
                                  _hoisted_16
                                ]),
                                (ficha.value.generalesMatados !== null)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                      _hoisted_18,
                                      _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(textoPorcentaje)(ficha.value.generalesMatados)), 1),
                                      _hoisted_20
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (ficha.value.resumen.torneos > 0)
                                ? (_openBlock(), _createBlock(_component_v_card, {
                                    key: 0,
                                    variant: "outlined",
                                    class: "seccion"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_21,
                                      _createElementVNode("div", _hoisted_22, [
                                        _createVNode(_component_v_chip, {
                                          size: "small",
                                          variant: "tonal"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(ficha.value.resumen.torneos) + " " + _toDisplayString(ficha.value.resumen.torneos === 1 ? "torneo" : "torneos"), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_chip, {
                                          size: "small",
                                          variant: ficha.value.resumen.torneosGanados > 0 ? 'flat' : 'tonal',
                                          color: 
                    ficha.value.resumen.torneosGanados > 0 ? '#FFD700' : undefined
                  
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(ficha.value.resumen.torneosGanados) + " " + _toDisplayString(ficha.value.resumen.torneosGanados === 1 ? "ganado" : "ganados"), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["variant", "color"]),
                                        _createVNode(_component_v_chip, {
                                          size: "small",
                                          variant: "tonal"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(ficha.value.resumen.podios) + " " + _toDisplayString(ficha.value.resumen.podios === 1 ? "podio" : "podios"), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("p", _hoisted_23, _toDisplayString(fraseTorneos.value), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_card, {
                                variant: "outlined",
                                class: "seccion"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_24,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ficha.value.porTramo, (tramo) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: tramo.tramo,
                                      class: "barra text-body-2"
                                    }, [
                                      _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(textoTramo)(tramo.tramo)), 1),
                                      _createVNode(_component_v_progress_linear, {
                                        "model-value": tramo.partidas ? tramo.porcentaje : 0,
                                        color: "primary",
                                        "bg-color": "grey",
                                        height: "8",
                                        rounded: ""
                                      }, null, 8, ["model-value"]),
                                      _createElementVNode("span", _hoisted_26, _toDisplayString(tramo.partidas ? _unref(textoPorcentaje)(tramo.porcentaje) : "—"), 1),
                                      _createElementVNode("span", _hoisted_27, _toDisplayString(tramo.partidas), 1)
                                    ]))
                                  }), 128))
                                ]),
                                _: 1
                              }),
                              (ficha.value.porTemporada.length > 1)
                                ? (_openBlock(), _createBlock(_component_v_card, {
                                    key: 1,
                                    variant: "outlined",
                                    class: "seccion"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_28,
                                      _hoisted_29,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ficha.value.porTemporada, (temporada) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: temporada.temporada,
                                          class: "fila-cuatro text-body-2"
                                        }, [
                                          _createElementVNode("span", _hoisted_30, _toDisplayString(temporada.temporada), 1),
                                          _createElementVNode("span", _hoisted_31, _toDisplayString(temporada.partidas), 1),
                                          _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(textoPorcentaje)(temporada.porcentaje)), 1),
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["text-right", _unref(colorRinde)(temporada.rinde)])
                                          }, _toDisplayString(_unref(textoRinde)(temporada.rinde)), 3)
                                        ]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_card, {
                                variant: "outlined",
                                class: "seccion"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_33,
                                  (ficha.value.rivales.length === 0)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_34, " Aún no tiene 5 partidas contra ningún ejército. "))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _hoisted_35,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rivalesVisibles.value, (rival) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: rival.ejercito,
                                            class: "fila-cuatro pulsable text-body-2",
                                            role: "button",
                                            tabindex: "0",
                                            onClick: ($event: any) => (verCruce(rival.ejercito)),
                                            onKeydown: _withKeys(($event: any) => (verCruce(rival.ejercito)), ["enter"])
                                          }, [
                                            _createElementVNode("span", _hoisted_37, [
                                              _createVNode(_component_v_icon, {
                                                color: _unref(colorBando)(rival.bando),
                                                size: "10",
                                                class: "mr-1"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("mdi-circle")
                                                ]),
                                                _: 2
                                              }, 1032, ["color"]),
                                              _createTextVNode(_toDisplayString(rival.ejercito), 1)
                                            ]),
                                            _createElementVNode("span", _hoisted_38, _toDisplayString(rival.partidas), 1),
                                            _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(textoPorcentaje)(rival.porcentaje)), 1),
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["text-right", _unref(colorRinde)(rival.rinde)])
                                            }, _toDisplayString(_unref(textoRinde)(rival.rinde)), 3)
                                          ], 40, _hoisted_36))
                                        }), 128)),
                                        (ficha.value.rivales.length > 6)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                              _createVNode(_component_v_btn, {
                                                variant: "text",
                                                size: "small",
                                                class: "text-none",
                                                onClick: _cache[0] || (_cache[0] = ($event: any) => (todosRivales.value = !todosRivales.value))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(todosRivales.value
                        ? "Solo los extremos"
                        : `Ver los ${ficha.value.rivales.length}`), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]))
                                          : _createCommentVNode("", true),
                                        _hoisted_41
                                      ], 64))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_card, {
                                variant: "outlined",
                                class: "seccion mb-0"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_42,
                                  (ficha.value.jugadores.length === 0)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_43, " Nadie lo ha llevado 5 veces o más. "))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _hoisted_44,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jugadoresVisibles.value, (jugador) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: jugador.idUsuario,
                                            class: "fila-cuatro text-body-2"
                                          }, [
                                            _createVNode(_component_router_link, {
                                              to: `/detalle-jugador/${jugador.idUsuario}`,
                                              class: "nombre enlace"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(jugador.nick), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["to"]),
                                            _createElementVNode("span", _hoisted_45, _toDisplayString(jugador.partidas), 1),
                                            _createElementVNode("span", _hoisted_46, _toDisplayString(_unref(textoPorcentaje)(jugador.porcentaje)), 1),
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["text-right", _unref(colorRinde)(jugador.rinde)])
                                            }, _toDisplayString(_unref(textoRinde)(jugador.rinde)), 3)
                                          ]))
                                        }), 128)),
                                        (ficha.value.jugadores.length > JUGADORES_DE_ENTRADA)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                              _createVNode(_component_v_btn, {
                                                variant: "text",
                                                size: "small",
                                                class: "text-none",
                                                onClick: _cache[1] || (_cache[1] = ($event: any) => (todosJugadores.value = !todosJugadores.value))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(todosJugadores.value
                        ? "Ver menos"
                        : `Ver los ${ficha.value.jugadores.length}`), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]))
                                          : _createCommentVNode("", true),
                                        _hoisted_48
                                      ], 64))
                                ]),
                                _: 1
                              })
                            ], 64))
                      ], 64))
                    : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                class: "text-none",
                onClick: cerrar
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cerrar")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})